import { render, staticRenderFns } from "./MoveBandwidthPackageModal.vue?vue&type=template&id=87bb94c8&scoped=true&"
import script from "./MoveBandwidthPackageModal.vue?vue&type=script&lang=js&"
export * from "./MoveBandwidthPackageModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveBandwidthPackageModal.vue?vue&type=style&index=0&id=87bb94c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb94c8",
  null
  
)

export default component.exports